import { useEffect, useState } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getBumpAgainSuggestion,
  transformBumpAgainSuggestionResponse,
} from '@marketplace-web/vas/vas-data'
import {
  usePromoAfterItemUploadContext,
  PromoAfterItemUpload,
} from '@marketplace-web/item-upload/after-upload-actions-feature'

import {
  getIsBumpAgainSuggestionSeen,
  setBumpAgainSuggestionAsSeen,
} from '../../../utils/bumpAgainSuggestionCap'

const useFetchBumpAgainSuggestion = () => {
  const isBumpAgainSuggestionSeen = getIsBumpAgainSuggestionSeen()

  const { fetch: fetchBumpAgainSuggestion, transformedData: bumpAgainSuggestionData } = useFetch(
    getBumpAgainSuggestion,
    transformBumpAgainSuggestionResponse,
  )

  const { currentPromotion } = usePromoAfterItemUploadContext()

  const [isPromoAfterItemUploadShown, setIsPromoAfterItemUploadShown] = useState(false)

  useEffect(
    function checkPromoAfterItemUpload() {
      if (!currentPromotion) return
      if (currentPromotion === PromoAfterItemUpload.Empty) return

      setIsPromoAfterItemUploadShown(true)
    },
    [currentPromotion],
  )

  useEffect(
    function fetchData() {
      if (isBumpAgainSuggestionSeen) return
      if (isPromoAfterItemUploadShown) return
      if (currentPromotion !== PromoAfterItemUpload.Empty) return

      fetchBumpAgainSuggestion()
    },
    [
      isBumpAgainSuggestionSeen,
      currentPromotion,
      isPromoAfterItemUploadShown,
      fetchBumpAgainSuggestion,
    ],
  )

  useEffect(
    function registerBumpAgainSuggestionAsSeen() {
      if (!bumpAgainSuggestionData?.bumpAgainSuggestion) return

      setBumpAgainSuggestionAsSeen()
    },
    [bumpAgainSuggestionData],
  )

  return {
    showBumpAgainSuggestion: !!bumpAgainSuggestionData?.bumpAgainSuggestion,
    soldItemId: bumpAgainSuggestionData?.bumpAgainSuggestion?.soldItemId,
  }
}

export default useFetchBumpAgainSuggestion
